import { useLanguage, t } from "../../../i18n";
import React from "react";
import { Card } from "react-bootstrap";
import { HiOutlineShieldCheck, HiOutlineExclamationCircle } from "react-icons/hi";
import "./SafetyCard.css";
const safetyTips = ["Do not make any advance payment without properly verifying the room and the lister.", "Visit the property in person before making a final decision.", "Prefer visiting with at least 1 or 2 trusted people for the first meeting.", "Confirm the exact room, rent amount, deposit, bills, and included facilities during the visit.", "Avoid sharing unnecessary personal, banking, or financial information.", "Be cautious if someone pressures you to pay urgently or refuses an in-person visit.", "Make sure the person showing the property is genuinely authorized to do so.", "Leave immediately if anything feels suspicious or unsafe."];
export default function SafetyCard() {
  useLanguage();
  return <Card className="bb-safety-card">
      <Card.Body>
        <div className="bb-safety-card__header">
          <div className="bb-safety-card__icon">
            <HiOutlineShieldCheck />
          </div>

          <div>
            <h3 className="bb-safety-card__title">{t("Safety Tips Before You Connect")}</h3>
            <p className="bb-safety-card__subtitle">{t("Please take basic precautions before visiting a property, sharing information, or making any payment.")}


            </p>
          </div>
        </div>

        <div className="bb-safety-card__tips">
          {safetyTips.map((tip, index) => <div key={index} className="bb-safety-card__tip">
              <span className="bb-safety-card__tip-bullet">
                <HiOutlineExclamationCircle />
              </span>
              <span className="bb-safety-card__tip-text">{t(tip)}</span>
            </div>)}
        </div>

        <div className="bb-safety-card__note">
          <span className="bb-safety-card__note-label">{t("Important:")}</span>{t(" ")}{t("BaytBuddy encourages all users to verify details independently before making any agreement or payment.")}


        </div>
      </Card.Body>
    </Card>;
}
